import { setSalaryRange } from "../../redux/action/userLocation";
import { fetchSalaryRangesForExperiences } from "../techrelevance.apis/fetchSalaryRange";
import {
  setUserCountry,
  setUserState,
  setUserTopCities,
  setCountryList,
  setUserStateList,
  setUserCity,
  setUserExperienceRange,
  setSalaryRangeSkeleton,
  setSalaryRangeSkeletonBox,
} from "../../redux/action/userLocation"; // Adjust import based on your Redux setup
import {
  fetchCountries,
  fetchStates,
  fetchTopCities,
  fetchCities,
  fetchCitiesCountries,
  fetchSalaryRangeByCitiesCountry,
} from "../techrelevance.apis/fetchSalaryRange";
import { retry } from "../../utils/GlobalFunctions";

export const fetchSalaryRangeFunction = async (
  skillName,
  defaultUserExperienceRange,
  userCurrentState,
  userCurrentCity,
  userCurrentCountry,
  dispatch
) => {
  try {    
    dispatch(setSalaryRangeSkeleton(true));
    dispatch(setSalaryRangeSkeletonBox(true));
    const results = await fetchSalaryRangesForExperiences(
      userCurrentCountry, // e.g., "India"
      userCurrentState, // e.g., "Gujarat"
      userCurrentCity, // e.g., null
      skillName, // e.g., "Java"
      defaultUserExperienceRange // e.g., [{ key: "37-38" }, { key: "39-40" }]
    );
    dispatch(setSalaryRange(results));
    dispatch(setSalaryRangeSkeleton(false));
    dispatch(setSalaryRangeSkeletonBox(false));
  } catch (error) {
    console.log(error);
  }
};
export const fetchSalaryRangeFunctionLocationData = async (
  skillName,
  defaultUserExperienceRange,
  userCurrentState,
  userCurrentCity,
  userCurrentCountry,
  dispatch
) => {
  try {    
    dispatch(setSalaryRangeSkeleton(true));

    const results = await fetchSalaryRangesForExperiences(
      userCurrentCountry, // e.g., "India"
      userCurrentState, // e.g., "Gujarat"
      userCurrentCity, // e.g., null
      skillName, // e.g., "Java"
      defaultUserExperienceRange // e.g., [{ key: "37-38" }, { key: "39-40" }]
    );
    dispatch(setSalaryRange(results));
    dispatch(setSalaryRangeSkeleton(false));
  } catch (error) {
    console.log(error);
  }
};

export const fetchLocationData = async (
  countryName,
  dispatch,
  skill,
  defaultUserExperienceRange,
  countries,
  experience
) => {
  try {
    // Retry fetchStates
    const { states } = await retry(() => fetchStates(countryName));
    dispatch(setUserStateList(states));    
    const defaultState = {
      name: countryName.capitalState,
      stateCode: countryName.stateCode,
      countryShortName: countryName.shortName,
    };
    dispatch(setUserState(defaultState));

    // Retry fetchCities
    await retry(() => fetchCitiesCountries(defaultState, dispatch));

    // Retry fetchTopCities
    const { cities } = await retry(() =>
      fetchTopCities(countryName, defaultState)
    );

    const citiesInstance = cities.map((c) => ({
      ...c,
      countryShortName: countryName.shortName,
    }));
    dispatch(setUserTopCities(citiesInstance));

    const defaultCity = cities[0] || {
      name: "",
      countryShortName: countryName.shortName,
    };
    dispatch(setUserCity(defaultCity));

    const defaultExperienceRange = defaultUserExperienceRange.slice(0, 7);

    fetchSalaryRangeFunctionLocationData(
      skill,
      defaultExperienceRange,
      defaultState,
      defaultCity,
      countryName,
      dispatch
    );    
    await fetchSalaryRangeByCitiesCountry(
      countryName,
      defaultState,
      cities,
      skill,
      experience,
      dispatch
    );

    return { states, cities };
  } catch (error) {
    console.error("Failed to fetch location data:", error);
    dispatch(setUserCountry({ name: "India", shortName: "IN" }));
    return null;
  }
};
